import { ReactNode } from "react";

import i18n from "i18n/i18n";
import { ConfirmOptions, useConfirm as useConfirmMui } from "material-ui-confirm";
import { useTranslation } from "react-i18next";

type ConfirmOptionsWithAdditionalDescription = ConfirmOptions & {
  additionalDescription?: ReactNode;
};

function useConfirm() {
  const { t } = useTranslation();
  const confirmMui = useConfirmMui();

  const confirm = ({ description, additionalDescription, ...props }: ConfirmOptionsWithAdditionalDescription = {}) => {
    return confirmMui({
      cancellationButtonProps: { color: "error" },
      confirmationText: t("confirm"),
      ...props,
      description: additionalDescription ? (
        <>
          {description}
          {description && (
            <>
              <br />
              <br />
            </>
          )}
          {additionalDescription}
        </>
      ) : (
        description
      ),
    });
  };

  const confirmUpsell = (props?: ConfirmOptions) => {
    return confirmMui({
      ...props,
      title: i18n.t("subscriptionUpsellModal.title"),
      description: i18n.t("subscriptionUpsellModal.description"),
      confirmationText: i18n.t("subscriptionUpsellModal.cta"),
    });
  };

  return {
    confirm,
    confirmUpsell,
  };
}

export default useConfirm;
